// Mantis #1453 — M001-D029 §6.1/§7, contract SAPI-D029-004: the WHOLE-BATCH
// refusal/failure banner. RA_OFFLINE (409) and NOT_LINKED/GROUP_NOT_MIRRORED
// (404) abort the entire submitGroupMembershipChanges request before any
// per-change outcome exists — there is nothing partial to report, so this
// renders one honest banner, not a per-member row. Per-change outcomes
// (applied/refused/failed) are rendered by RealmAuthorityMembershipOutcomes
// instead — see that component for DOOR_WRITE_BLOCKED and per-change
// refusal handling.
import React from 'react';
import './realmAuthority.css';

export const RA_OFFLINE_TEXT = 'RealmAuthority is offline.';
// M004-F0670: the heading for a 200 that did not project, and for any other
// failure without a specific code. Neither may claim RealmAuthority refused or
// did not apply the change — a dispatched command can have applied even when
// its answer is unreadable, lost to a timeout, or wrapped in a 5xx.
export const UNVERIFIED_RESULT_HEADING = 'The result of this change could not be confirmed.';
export const UNVERIFIED_RESULT_TEXT = 'Core answered, but the answer did not match the agreed response shape, so this page cannot tell whether RealmAuthority applied the change. The membership shown has been re-read from Core; staged changes it does not reflect are kept. Check the membership before saving again.';
export const UNCONFIRMED_HEADING = 'RealmAuthority did not confirm this change.';

const CODE_TEXT = {
  RA_OFFLINE: RA_OFFLINE_TEXT,
  NOT_LINKED: 'No RealmAuthority realm is linked to this organisation.',
  GROUP_NOT_MIRRORED: 'This group is no longer mirrored from RealmAuthority.',
  UNVERIFIED_RESULT: UNVERIFIED_RESULT_HEADING,
};

export default function RealmAuthorityRefusalNotice({ notice, onClose }) {
  if (!notice) return null;
  const heading = CODE_TEXT[notice.code] || UNCONFIRMED_HEADING;
  return (
    <div className="ra-refusal ra-refusal--failed" role="alert" data-testid="ra-refusal-notice">
      <div>
        <strong>{heading}</strong>
        {notice.message && notice.message !== heading ? <span className="ra-refusal-code"> {notice.message}</span> : null}
        {notice.lastSnapshotAt ? <span className="ra-refusal-snapshot"> Last snapshot: {notice.lastSnapshotAt}</span> : null}
        {notice.diagnostic ? (
          <span className="ra-refusal-diagnostic" data-testid="ra-refusal-diagnostic"> Diagnostic: {notice.diagnostic}</span>
        ) : null}
      </div>
      {onClose ? (
        <button type="button" className="ra-refusal-close" onClick={onClose}>Dismiss</button>
      ) : null}
    </div>
  );
}
